import FullTextSearch from "./FullTextSearch"

export default  FullTextSearch;



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubHeader/FullTextSearch/index.js